// Locale-aware number formatting.
// AR uses Arabic-Indic numerals (٠١٢٣...).
// Intl.NumberFormat('ar-EG') uses U+066C (٬) as the thousands separator, which
// renders above the baseline in many Arabic fonts (Amiri included). We swap it
// for U+060C (،) — the Arabic comma — which sits at baseline like a Western
// comma and is the standard Arabic punctuation mark.

import type { Locale } from '../i18n'

const TAG: Record<Locale, string> = { en: 'en-US', ar: 'ar-EG' }
const AR_THOUSANDS_SEP = '٬' // ٬ — renders too high
const AR_COMMA = '،'         // ، — sits at baseline

export function fmt(n: number, locale: Locale, opts?: Intl.NumberFormatOptions): string {
  const s = new Intl.NumberFormat(TAG[locale], opts).format(n)
  return locale === 'ar' ? s.replaceAll(AR_THOUSANDS_SEP, AR_COMMA) : s
}

/** Format a year. We render as plain digits without grouping. */
export function fmtYear(year: number, locale: Locale): string {
  return fmt(year, locale, { useGrouping: false, maximumFractionDigits: 0 })
}
